import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Fuel Components
import { FuelHistoryComponent } from './fuel-history/fuel-history.component';
import { FuelHistoryDetailComponent } from './fuel-history/fuel-history-detail/fuel-history-detail.component';
import { FuelOrderComponent } from './fuel-order/fuel-order.component';
import { FuelOrderDetailComponent } from './fuel-order/fuel-order-detail/fuel-order-detail.component';
import { FuelRequestsComponent } from './fuel-requests/fuel-requests.component';

const FuelComponents = [
  FuelHistoryComponent,
  FuelHistoryDetailComponent,
  FuelOrderComponent,
  FuelOrderDetailComponent,
  FuelRequestsComponent
];

@NgModule({
  declarations: FuelComponents,
  imports: [SharedModule],
  exports: FuelComponents
})
export class FuelModule { }
